/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react'
import { getTemplateCommentHistory } from 'src/services/templateService';
import {
    Avatar,
    Typography,
    Box,
    Divider,
    Stack,
    TextField
} from "@mui/material";

interface TemplateCommentHistoryProps {
    templateId: number;
    templateName: string;
}

function TemplateCommentHistory({ templateId, templateName }: TemplateCommentHistoryProps): JSX.Element {

    const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const [comments, setComments] = React.useState<any[]>([]);

    useEffect(() => {
        setIsLoading(true);
        getTemplateCommentHistory(templateId).then(response => {
            console.log('Template Comment History:', response);
            if (response.status === 200 && response.data.result === 1) {
                setComments(response.data.data);
            } else {
                setComments([]);
            }
        }).catch(error => {
            console.error('Error fetching template comment history:', error);
        })
            .finally(() => {
                setIsLoading(false);
            });

    }, [templateId, templateName]);
    console.log('TemplateCommentHistory', templateId, templateName);
    return (
        <div className="relative px-[16px] pt-[10px]">
            <div className='w-full relative mb-[30px] role-input-container disabled'>
                <TextField
                id="outlined-basic"
                    fullWidth
                    label="Template name"
                    autoComplete="off"
                    value={templateName}
                    InputProps={{
                       style: {
                        textAlign: "center",
                        color: '#343434 !important',
                        fontSize: '18px !important',
                        fontWeight: '700 !important',
                        WebkitTextFillColor: '#343434 !important',
                        padding: '9px 14px 9px 25px',

                    },

                    }}
                   sx={{
                        '& input': {
                            textAlign: 'center',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        },
                        '& label': {
                            textAlign: 'center',
                        },
                        backgroundColor: '#F5F5F5',
                        }}
                    disabled={true}
                />
            </div>
            {
                isLoading ? (
                    <div className='flex justify-center items-center relative '><span className="loading loading-spinner text-primary"></span></div>
                ) :

                    (<Box>
                        {comments.map((c, index) => (
                            <Box key={index} sx={{ mb: 2 }}>
                                <Stack direction="row" spacing={2} alignItems="flex-start">
                                    {/* Avatar with initials */}
                                    <Avatar sx={{ bgcolor: "#e0e0e0", color: "black" }}>
                                        {c.commentedBy
                                            .split(" ")
                                            .map((n: any) => n[0])
                                            .join("")}
                                    </Avatar>

                                    {/* Name, Date, and Message */}
                                    <Box>
                                        <Typography variant="body1" component="span" fontWeight="bold">
                                            {c.commentedBy}
                                        </Typography>{" "}
                                        <Typography
                                            variant="caption"
                                            component="span"
                                            sx={{ color: "text.secondary" }}
                                        >
                                            {c.commentedOn}
                                        </Typography>
                                        <Typography variant="body2" sx={{ mt: 0.5 }}>
                                            {c.message}
                                        </Typography>

                                        {/* Attached Files */}
                                        {c.commentFiles.length > 0 && (
                                            <Box sx={{ mt: 1 }}>
                                                {c.commentFiles.map((file: any, i: number) => (
                                                    <Typography
                                                        key={i}
                                                        variant="caption"
                                                        component="a"
                                                        href={file.fileURL}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        sx={{ display: "block", color: "primary.main" }}
                                                    >
                                                        📎 {file.fileName}
                                                    </Typography>
                                                ))}
                                            </Box>
                                        )}
                                    </Box>
                                </Stack>

                                {/* Divider */}
                                {index !== comments.length - 1 && (
                                    <Divider sx={{ mt: 2, mb: 1 }} />
                                )}
                            </Box>
                        ))}
                    </Box>)
            }
        </div>
    )
}

export default TemplateCommentHistory